/**
 * @typedef {(STARTED)} TypeState A state.
 */

/**
 * The 'STARTED' state.
 * @type {'STATE_STARTED'}
 * @constant
 */
const STARTED = 'STATE_STARTED';

export {

    STARTED
};
